import { useContext } from 'react';

import { BootstrapContext, BootstrapContextData } from 'contexts';

export function useBootstrapApp(): BootstrapContextData {
  const context = useContext(BootstrapContext);

  return context;
}
